import { Component, input } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';

@Component({
    selector: 'app-map-widget',
    imports: [GoogleMapsModule],
    templateUrl: './map-widget.component.html',
    styleUrls: ['./map-widget.component.scss']
})
export class MapWidgetComponent {
  readonly position = input<{
    lat: number;
    lng: number;
  } | undefined>(undefined);
}
